import React from "react";
import { Helmet } from "react-helmet-async";
import "./DigitalMarketingSMEs.css";

// Hero Image
import MarketingHeroImg from "../assets/about-cta.jpeg";

const DigitalMarketingSMEs = () => {

  const handleCTAClick = () => {
    if (window.gtag) {
      window.gtag("event", "click", {
        event_category: "CTA",
        event_label: "WhatsApp SME CTA",
        value: 1,
      });
    }
  };

  

  return (
    <>
      {/* SEO */}
      <Helmet>
        <title>Digital Marketing for SMEs in Kenya | Grow Your Business Online</title>

<link rel="canonical" href="https://satimatechnova.co.ke/digital-marketing-smes/" />
        <meta
          name="description"
          content="Grow your SME with professional digital marketing services in Kenya. Satima Technova helps businesses generate leads through SEO, social media marketing, paid ads and content strategies."
        />

        <meta
          name="keywords"
          content="digital marketing SMEs Kenya, SEO Kenya, social media marketing Kenya, PPC Kenya, online marketing Kenya, Satima Technova Solutions"
        />

        <meta name="author" content="Satima Technova" />

        {/* Open Graph */}
        <meta property="og:title" content="Digital Marketing for SMEs in Kenya" />
        <meta property="og:description" content="Grow your SME with proven digital marketing strategies in Kenya." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://satimatechnova.co.ke/digital-marketing-smes/" />




        <script type="application/ld+json">
{JSON.stringify({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "How much does digital marketing cost?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Satima Technova Solutions offers flexible digital marketing packages for businesses in Kenya. Our Basic Package starts from KSh 6,000 per month, while our Premium Package starts from KSh 12,000 per month. We can also recommend a customized strategy based on your business goals and budget."
      }
    },
    {
      "@type": "Question",
      "name": "How long does it take to see results from digital marketing?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The time required to see results depends on the marketing strategy used. Paid advertising can generate leads faster, while SEO and content marketing usually require more time to build sustainable growth. Satima focuses on strategies that deliver measurable long-term results."
      }
    },
    {
      "@type": "Question",
      "name": "Which businesses do you work with?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Satima Technova Solutions works with startups, SMEs, professional service providers, retailers, e-commerce businesses, and other organizations looking to improve their online presence and attract more customers."
      }
    },
    {
      "@type": "Question",
      "name": "Do I need a website before starting digital marketing?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "A website is not always required to start digital marketing, but having a professional website improves credibility, helps convert visitors into customers, and provides a central platform for your online presence."
      }
    },
    {
      "@type": "Question",
      "name": "What digital marketing services are included?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Our digital marketing services include SEO, Social Media Marketing, Pay-Per-Click Advertising, Content Marketing, Email Marketing, Analytics, and Reporting to help businesses improve visibility and generate leads."
      }
    },
    {
      "@type": "Question",
      "name": "How do I get started with digital marketing services?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "To get started, contact Satima Technova Solutions for a free consultation. We will understand your business goals, recommend the right strategy, and guide you through the next steps."
      }
    }
  ]
})}
</script>

      </Helmet>

      <main className="dm-page">


        {/* TRUST SCROLLING BAR */}
<section className="dm-trust-scroll">

  <div className="dm-trust-track">

    <div className="dm-trust-content">

      <span>✓ SME-Focused Strategies</span>

      <span>✓ Data-Driven Marketing</span>

      <span>✓ Results Tracking</span>

      <span>✓ Complete Digital Solutions</span>

    </div>


    {/* Duplicate for seamless scrolling */}

    <div className="dm-trust-content">

      <span>✓ SME-Focused Strategies</span>

      <span>✓ Data-Driven Marketing</span>

      <span>✓ Results Tracking</span>

      <span>✓ Complete Digital Solutions</span>

    </div>

  </div>

</section>



{/* =========================================================
    DIGITAL MARKETING HERO
========================================================= */}

<section
  className="dm-hero-section"
  style={{
    backgroundImage: `url(${MarketingHeroImg})`
  }}
>

  <div className="dm-hero-overlay">

    <div className="dm-hero-wrapper">

      <div className="dm-hero-text">

        {/* SEO HEADING */}

        <h1 className="sr-only">
          Digital Marketing for SMEs in Kenya
        </h1>


        {/* HERO CONTENT */}

        <div className="dm-intro-content">

          <span className="dm-hero-kicker">
            STRATEGIC DIGITAL MARKETING
          </span>

          <h2>
            Marketing With
            <br />
            <span>Direction.</span>
          </h2>

          <p className="dm-intro-line">
            We help businesses attract the right customers, generate
            quality leads, and grow online through strategic digital
            marketing built around measurable results.
          </p>

        </div>


        {/* CTA */}

        <a
          href="https://wa.me/254775137928?text=Hi%20Satima%20Technova,%20I%E2%80%99m%20interested%20in%20digital%20marketing%20services%20for%20my%20SME."
          target="_blank"
          rel="noopener noreferrer"
          className="dm-hero-cta"
          onClick={handleCTAClick}
        >
          Talk To A Marketing Expert
        </a>


        {/* TRUST POINTS */}

        <div className="dm-trust-points">

          <p>
            <span>01</span>
            Lead-focused strategies
          </p>

          <p>
            <span>02</span>
            SEO • Social Media • Google Ads
          </p>

          <p>
            <span>03</span>
            Built for measurable growth
          </p>

        </div>

      </div>

    </div>

  </div>

</section>




{/* MARKETING GAP SECTION */}

<section id="marketing-gap" className="dm-gap-section">

  <div className="dm-gap-container">

    {/* SECTION HEADER */}

    <div className="dm-gap-header">

      <span className="dm-gap-label">
        THE MARKETING GAP
      </span>

      <h2>
        More Marketing Doesn't Always
        <br />
        <span>Mean More Customers.</span>
      </h2>

    </div>


    {/* MARKETING COMPARISON */}

    <div className="dm-gap-feature">

      {/* RANDOM MARKETING */}

      <div className="dm-gap-random">

        <div className="dm-gap-side-top">

          <span className="dm-gap-number">
            01
          </span>

          <span className="dm-gap-side-label">
            RANDOM MARKETING
          </span>

        </div>

        <h3>
          Activity without
          <br />
          <span>direction.</span>
        </h3>

        <p className="dm-gap-side-intro">
          Marketing becomes a collection of disconnected
          activities instead of a focused business strategy.
        </p>

        <div className="dm-gap-list">

          <div className="dm-gap-list-item">
            <span>01</span>
            <p>Posting without a clear purpose</p>
          </div>

          <div className="dm-gap-list-item">
            <span>02</span>
            <p>Running ads without understanding the audience</p>
          </div>

          <div className="dm-gap-list-item">
            <span>03</span>
            <p>Chasing followers instead of meaningful actions</p>
          </div>

          <div className="dm-gap-list-item">
            <span>04</span>
            <p>Spending without knowing what is working</p>
          </div>

        </div>

      </div>


      {/* STRATEGIC MARKETING */}

      <div className="dm-gap-strategic">

        <div className="dm-gap-side-top">

          <span className="dm-gap-number">
            02
          </span>

          <span className="dm-gap-side-label">
            STRATEGIC MARKETING
          </span>

        </div>

        <h3>
          Every channel has
          <br />
          <span>a purpose.</span>
        </h3>

        <p className="dm-gap-side-intro">
          We connect your audience, message, channels, and
          goals into one focused marketing system.
        </p>

        <div className="dm-gap-list">

          <div className="dm-gap-list-item">
            <span>01</span>
            <p>Reach the right audience</p>
          </div>

          <div className="dm-gap-list-item">
            <span>02</span>
            <p>Build interest and trust</p>
          </div>

          <div className="dm-gap-list-item">
            <span>03</span>
            <p>Turn attention into enquiries</p>
          </div>

          <div className="dm-gap-list-item">
            <span>04</span>
            <p>Measure performance and improve</p>
          </div>

        </div>

      </div>

    </div>


    {/* CLOSING STATEMENT */}

    <div className="dm-gap-closing">

      <span className="dm-gap-closing-line"></span>

      <p>
        Your business doesn't need
        <strong> more marketing noise.</strong>
        It needs direction.
      </p>

    </div>

  </div>

</section>




{/* =====================================
    DIGITAL MARKETING SERVICES SECTION
===================================== */}

<section className="dm-services-section">

  <div className="dm-services-container">

    {/* SECTION HEADER */}

    <div className="dm-services-header">

      <span className="dm-services-label">
        WHAT WE DO
      </span>

      <h2 className="visually-hidden">
        Digital Marketing With Purpose.
      </h2>

      <p>
        Focused marketing services designed to attract the right audience,
        create demand, and turn attention into meaningful action.
      </p>

    </div>


    {/* SERVICES LIST */}

    <div className="dm-services-list">


      {/* SEO */}

      <div className="dm-service-row">

        <div className="dm-service-number">
          01
        </div>

        <div className="dm-service-icon">
          <i className="fas fa-search"></i>
        </div>

        <div className="dm-service-content">

          <h3>
            SEO
          </h3>

          <p>
            Improve search visibility and help the right customers find you.
          </p>

        </div>

        <span className="dm-service-arrow">
          →
        </span>

      </div>


      {/* SOCIAL MEDIA */}

      <div className="dm-service-row">

        <div className="dm-service-number">
          02
        </div>

        <div className="dm-service-icon">
          <i className="fas fa-share-alt"></i>
        </div>

        <div className="dm-service-content">

          <h3>
            Social Media Marketing
          </h3>

          <p>
            Build your presence, engage your audience, and strengthen your brand.
          </p>

        </div>

        <span className="dm-service-arrow">
          →
        </span>

      </div>


      {/* PPC */}

      <div className="dm-service-row">

        <div className="dm-service-number">
          03
        </div>

        <div className="dm-service-icon">
          <i className="fas fa-bullhorn"></i>
        </div>

        <div className="dm-service-content">

          <h3>
            PPC Advertising
          </h3>

          <p>
            Reach high-intent customers through targeted paid search campaigns.
          </p>

        </div>

        <span className="dm-service-arrow">
          →
        </span>

      </div>


      {/* FACEBOOK & INSTAGRAM ADS */}

      <div className="dm-service-row">

        <div className="dm-service-number">
          04
        </div>

        <div className="dm-service-icon">
          <i className="fab fa-facebook-f"></i>
        </div>

        <div className="dm-service-content">

          <h3>
            Facebook & Instagram Ads
          </h3>

          <p>
            Put your offers in front of targeted audiences and generate enquiries.
          </p>

        </div>

        <span className="dm-service-arrow">
          →
        </span>

      </div>


      {/* EMAIL MARKETING */}

      <div className="dm-service-row">

        <div className="dm-service-number">
          05
        </div>

        <div className="dm-service-icon">
          <i className="fas fa-envelope"></i>
        </div>

        <div className="dm-service-content">

          <h3>
            Email Marketing
          </h3>

          <p>
            Stay connected with customers through focused, relevant email campaigns.
          </p>

        </div>

        <span className="dm-service-arrow">
          →
        </span>

      </div>


      {/* CONTENT MARKETING */}

      <div className="dm-service-row">

        <div className="dm-service-number">
          06
        </div>

        <div className="dm-service-icon">
          <i className="fas fa-pen-nib"></i>
        </div>

        <div className="dm-service-content">

          <h3>
            Content Marketing
          </h3>

          <p>
            Create useful content that builds trust and supports your marketing goals.
          </p>

        </div>

        <span className="dm-service-arrow">
          →
        </span>

      </div>


      {/* GOOGLE BUSINESS PROFILE */}

      <div className="dm-service-row">

        <div className="dm-service-number">
          07
        </div>

        <div className="dm-service-icon">
          <i className="fas fa-map-marker-alt"></i>
        </div>

        <div className="dm-service-content">

          <h3>
            Google Business Profile
          </h3>

          <p>
            Improve your local visibility and help nearby customers discover your business.
          </p>

        </div>

        <span className="dm-service-arrow">
          →
        </span>

      </div>


    </div>


    {/* CLOSING STATEMENT */}

    <div className="dm-services-closing">

      <span className="dm-services-closing-line"></span>

      <p>
        Every channel should have a role.
        <strong> Every action should have a purpose.</strong>
      </p>

    </div>

  </div>

</section>

{/* =========================================================
    WHY CHOOSE SATIMA — DIGITAL MARKETING
========================================================= */}

<section className="dm-why-section">

  <div className="dm-why-container">

    {/* SECTION INTRO */}

    <div className="dm-why-header">

      <span className="dm-why-label">
        WHY CHOOSE SATIMA
      </span>

      <h2>
        Why Choose Satima for
        <br />
        Digital Marketing
      </h2>

      <p>
        We help SMEs in Kenya approach digital marketing with
        strategy, structure, and a clear focus on business results.
      </p>

    </div>


    {/* MAIN CARD */}

    <div className="dm-why-card">

      <div className="dm-why-accent"></div>


      <div className="dm-why-content">

        {/* STATEMENT */}

        <div className="dm-why-statement">

          <span className="dm-why-quote">
            “
          </span>

          <h3>
            Marketing.
            <br />
            <span>With Direction.</span>
          </h3>

        </div>


        {/* MESSAGE */}

        <div className="dm-why-message">

          <p>
            We believe effective digital marketing starts with
            <strong> understanding your business.</strong> Every
            campaign should have a clear purpose and a way to
            measure whether it is moving you forward.
          </p>


          {/* PRINCIPLES */}

          <div className="dm-why-principles">

            <div className="dm-why-principle">

              <span className="dm-why-number">
                01
              </span>

              <div>
                <h4>
                  Results Driven
                </h4>

                <p>
                  We build campaigns around meaningful objectives,
                  from visibility and enquiries to customer acquisition.
                </p>
              </div>

            </div>


            <div className="dm-why-principle">

              <span className="dm-why-number">
                02
              </span>

              <div>
                <h4>
                  SME Focused
                </h4>

                <p>
                  We understand the realities of growing businesses
                  and build strategies around your goals and resources.
                </p>
              </div>

            </div>


            <div className="dm-why-principle">

              <span className="dm-why-number">
                03
              </span>

              <div>
                <h4>
                  Clear Performance
                </h4>

                <p>
                  We track meaningful results so you can understand
                  what is working and where your marketing needs to improve.
                </p>
              </div>

            </div>

          </div>


          {/* HIGHLIGHT */}

          <div className="dm-why-highlight">

            <span className="dm-why-highlight-line"></span>

            <p>
              Your business doesn't need
              <strong> more marketing activity.</strong>
              It needs marketing that has a reason.
            </p>

          </div>

        </div>

      </div>

    </div>

  </div>

</section>


        {/* =====================================
    FAQ SECTION
===================================== */}

<section className="faq-section">

  <div className="faq-header">

    <h2>Frequently Asked Questions</h2>

    <p>
      Find answers to the most common questions about our digital marketing
      services for businesses in Kenya.
    </p>

  </div>


  <div className="faq-container">

    <details className="faq-item" open>

      <summary>
        How much does digital marketing cost?
      </summary>

      <p>
        We offer flexible monthly packages designed for businesses of different sizes.
      </p>

      <ul>

        <li>
          <strong>Basic Package:</strong> KSh 6,000 per month
        </li>

        <li>
          <strong>Premium Package:</strong> KSh 12,000 per month
        </li>

      </ul>

      <p>
        Every business is different, so we can also recommend a customized strategy
        based on your goals and budget.
      </p>

    </details>



    <details className="faq-item">

      <summary>
        How long does it take to see results?
      </summary>

      <p>
        Results depend on the marketing channels used. Paid advertising can
        generate leads quickly, while SEO and content marketing typically build
        momentum over several months. We focus on sustainable long-term growth.
      </p>

    </details>



    <details className="faq-item">

      <summary>
        Which businesses do you work with?
      </summary>

      <p>
        We work with startups, SMEs, professional service providers,
        retailers, construction companies, e-commerce businesses,
        healthcare providers, and many other industries across Kenya.
      </p>

    </details>



    <details className="faq-item">

      <summary>
        Do I need a website before starting digital marketing?
      </summary>

      <p>
        Not always. However, having a professional website improves your
        credibility, increases conversions, and gives customers a central
        place to learn about your business and services.
      </p>

    </details>



    <details className="faq-item">

      <summary>
        What digital marketing services are included?
      </summary>

      <p>
        Depending on your package, services may include Search Engine
        Optimization (SEO), Social Media Marketing, Google Ads,
        Content Marketing, Email Marketing, Analytics & Reporting,
        and ongoing strategy support.
      </p>

    </details>



    <details className="faq-item">

      <summary>
        How do I get started?
      </summary>

      <p>
        Simply contact Satima Technova Solutions for a free consultation.
        We'll learn about your business, discuss your goals, and recommend
        the most suitable digital marketing package.
      </p>

    </details>

  </div>

</section>

          


{/* PREMIUM DIGITAL MARKETING CTA */}

<section className="dm-final-cta">

  <div className="dm-final-cta-inner">

    <span className="dm-final-cta-label">
      READY TO GROW?
    </span>

    <h2 className="dm-final-cta-title">
      Turn Your Digital
      <br />
      <span>Presence Into Results.</span>
    </h2>

    <p className="dm-final-cta-text">
      Let's build a focused digital marketing strategy that
      attracts the right audience and creates meaningful action.
    </p>

    <a
      href="https://wa.me/254775137928?text=Hi%20Satima%20Technova,%20I'm%20interested%20in%20your%20Digital%20Marketing%20services."
      target="_blank"
      rel="noopener noreferrer"
      className="dm-final-cta-button"
      onClick={handleCTAClick}
    >
      Start A Conversation
      <span>→</span>
    </a>

  </div>

</section>






      </main>
    </>
  );
};

export default DigitalMarketingSMEs;